import React from 'react';
import { ChevronDown, ChevronUp, X } from 'lucide-react';

const FilterPanel = ({ 
  availableFilters, 
  selectedFilters, 
  expandedFilters, 
  toggleFilter, 
  toggleExpandFilter, 
  clearFilters 
}) => {
  return (
    <div className="bg-gray-50 rounded-lg p-4 mb-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="font-medium text-gray-800">Filters</h3>
        {Object.values(selectedFilters).some(arr => arr.length > 0) && (
          <button
            onClick={clearFilters}
            className="text-xs text-primaryDark hover:text-primaryDark"
          >
            Clear All
          </button>
        )}
      </div>

      {Object.entries(availableFilters).map(([category, options]) => (
        <div key={category} className="mb-4">
          <div
            className="flex justify-between items-center cursor-pointer mb-2"
            onClick={() => toggleExpandFilter(category)}
          >
            <h4 className="text-sm font-medium text-gray-700 capitalize">
              {category}
              {selectedFilters[category].length > 0 && (
                <span className="ml-2 text-xs bg-blue-100 text-primaryDark px-1.5 py-0.5 rounded-full">
                  {selectedFilters[category].length}
                </span>
              )}
            </h4>
            {expandedFilters[category] ? (
              <ChevronUp size={16} className="text-gray-500" />
            ) : (
              <ChevronDown size={16} className="text-gray-500" />
            )}
          </div>

          {expandedFilters[category] && (
            <div className="pl-2 space-y-1">
              {options.map(option => (
                <div key={option.id} className="flex items-center">
                  <input
                    type="checkbox"
                    id={option.id}
                    checked={selectedFilters[category].includes(option.id)}
                    onChange={() => toggleFilter(category, option.id)}
                    className="h-4 w-4 text-primaryDark focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <label htmlFor={option.id} className="ml-2 text-sm text-gray-700">
                    {option.name}
                  </label>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FilterPanel;